/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useState, useEffect } from 'react'
import { getIdData, addData, updateData } from '../../../../lib/activitylist'
import { useNavigate, useParams } from 'react-router-dom'
import { ClassForLessonSelectForActivities } from '../../../ui/myselect'
import { RecognitionLevelSelect, CategorySelectForActivity, PositionSelectForActivity } from '../../../ui/myselect'
import { useAuth } from '../../../../usercontext'

export default function ActivityEdit({ slug, Id, status }) {
	const [gradelevel, setGradelevel] = useState()
	const [hoursperweek, setHoursperweek] = useState()
	const [weeksperyear, setWeeksperyear] = useState()
	const [recoglevel, setRecoglevel] = useState()
	const [sortOrder, setSortOrder] = useState(0)
	const [category, setCategory] = useState()
	const [position, setPosition] = useState()
	const [description, setDescription] = useState()
	const [data, setData] = useState([])

	const { profile } = useAuth()

	const navigate = useNavigate()
	//let { slug ,Id ,status} = useParams();

	async function GetData() {
		//data
		const organizationData = await getIdData(Id)
		setData(organizationData)
		setCategory(organizationData[0].category)
		setPosition(organizationData[0].position)
		setGradelevel(organizationData[0].gradelevel)
		setRecoglevel(organizationData[0].recoglevel)
		setHoursperweek(organizationData[0].hoursperweek)
		setWeeksperyear(organizationData[0].weeksperyear)
		setSortOrder(organizationData[0].sortorder)
		setDescription(organizationData[0].description)

		//isDisabled = {slug === "Add" ? false : true}
	}

	const handleSubmit = async (e) => {
		e.preventDefault()

		if (status === 'Add') {
			await addData({
				studentId: slug,
				gradelevel: gradelevel,
				recoglevel: recoglevel,
				hoursperweek: hoursperweek,
				weeksperyear: weeksperyear,
				category: category,
				position: position,
				sortorder: sortOrder,
				description: description
			})
		} else {
			console.log('Update')
			await updateData({
				id: Id,
				gradelevel: gradelevel,
				recoglevel: recoglevel,
				hoursperweek: hoursperweek,
				weeksperyear: weeksperyear,
				category: category,
				position: position,
				sortorder: sortOrder,
				description: description
			})
		}

		navigate(-1)
		//navigate(`/instructor/instructor-studentactivitiesandawards/${slug}`);
	}

	useEffect(() => {
		if (status === 'Update') {
			GetData()
		}
	}, [status])
	return (
		// <div className="settings-widget profile-details">
		<div className="settings-menu p-2">
			<div className="profile-heading p-2">
				<h3>{status === 'Add' ? 'Add Activity' : 'Update Activity'}</h3>
			</div>
			<div className="checkout-form personal-address add-course-info ">
				<form role="form" onSubmit={handleSubmit}>
					<div className="row mx-auto">
						<div className="col-9">
							<div className="form-group">
								<label className="form-control-label">Grade Level</label>
								<ClassForLessonSelectForActivities value={gradelevel} name={'Grade Level'} setValue={setGradelevel} />
							</div>
						</div>
						<div className="col-9">
							<div className="form-group">
								<label className="form-control-label">Hours Per Week</label>
								<input
									type="number"
									value={hoursperweek}
									onChange={(e) => setHoursperweek(e.target.value)}
									className="form-control"
									placeholder="Hours Per Week"
									min="0"
								/>
							</div>
						</div>
						<div className="col-9">
							<div className="form-group">
								<label className="form-control-label">Weeks Per Year</label>
								<input
									type="number"
									value={weeksperyear}
									onChange={(e) => setWeeksperyear(e.target.value)}
									className="form-control"
									placeholder="Weeks Per Year"
									min="0"
								/>
							</div>
						</div>
						<div className="col-9">
							<div className="form-group">
								<label className="form-control-label">Recognition Level</label>
								<RecognitionLevelSelect value={recoglevel} setValue={setRecoglevel} />
							</div>
						</div>

						<div className="col-9">
							<div className="form-group">
								<label className="form-control-label">Category</label>
								<CategorySelectForActivity value={category} setValue={setCategory} />
							</div>
						</div>

						<div className="col-9">
							<div className="form-group">
								<label className="form-control-label">Position</label>
								<PositionSelectForActivity value={position} setValue={setPosition} />
							</div>
						</div>

						<div className="col-9">
							<div className="form-group">
								<label className="form-control-label">Description</label>
								<textarea
									rows="4"
									value={description}
									onChange={(e) => setDescription(e.target.value)}
									className="form-control"
									placeholder="Description"
								></textarea>
							</div>
						</div>

						<div className="col-9">
							<div className="form-group">
								<label className="form-control-label">Order</label>
								<input type="number" value={sortOrder} onChange={(e) => setSortOrder(e.target.value)} className="form-control" required />
							</div>
						</div>

						<div className="update-profile d-flex justify-content-between">
							<button type="submit" className="btn btn-primary">
								{status === 'Add' ? 'Add Activity' : 'Update Activity'}
							</button>
							<button onClick={() => navigate(-1)} className="btn btn-black btn-sm">
								Cancel
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		// </div>
	)
}
